import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/data/site";
import { WVELink } from "@/components/WVELink";

export default function Footer() {
  return (
    <footer className="bg-bde-ink text-bde-cream relative overflow-hidden" data-testid="site-footer">
      <div className="container-wide py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="eyebrow text-bde-pink"><WVELink className="!no-underline hover:!text-bde-pinkHover">{BRAND.parent}</WVELink> · est. {BRAND.established}</p>
            <h3 className="font-display text-4xl md:text-5xl leading-none mt-4">
              Let's make
              <br />
              <span className="text-bde-pink italic">the best day</span> of your life
              <br />
              last forever.
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="mt-8 inline-flex items-center gap-2 border-2 border-bde-pink text-bde-pink hover:bg-bde-pink hover:text-white font-mono uppercase tracking-[0.18em] text-xs px-6 py-4 transition-all duration-150"
            >
              Check My Date →
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-bde-cream/60">Navigate</p>
            <ul className="mt-4 space-y-2 font-display text-lg">
              <li><Link to="/" className="hover:text-bde-pink transition-colors">Home</Link></li>
              <li><Link to="/work" className="hover:text-bde-pink transition-colors">Work</Link></li>
              <li><Link to="/about" className="hover:text-bde-pink transition-colors">About</Link></li>
              <li><Link to="/packages" className="hover:text-bde-pink transition-colors">Packages</Link></li>
              <li><Link to="/booth" className="hover:text-bde-pink transition-colors">Video Booth</Link></li>
              <li><Link to="/reviews" className="hover:text-bde-pink transition-colors">Reviews</Link></li>
              <li><Link to="/faq" className="hover:text-bde-pink transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-bde-pink transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-bde-cream/60">Say hi</p>
            <ul className="mt-4 space-y-3 text-base font-light">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-bde-pink" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-bde-pink" data-testid="footer-email">{BRAND.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram className="h-4 w-4 text-bde-pink" />
                <a href={`https://instagram.com/${BRAND.instagram.replace('@','')}`} target="_blank" rel="noreferrer" className="hover:text-bde-pink">{BRAND.instagram}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-bde-pink mt-1 flex-shrink-0" />
                <span>{BRAND.baseAddress}</span>
              </li>
            </ul>
            <p className="mt-8 text-xs font-mono uppercase tracking-[0.22em] text-bde-cream/50">
              CAA-approved drone pilots · Klarna available · Fully insured
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-bde-cream/15">
        <div className="container-wide py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs font-mono uppercase tracking-[0.22em] text-bde-cream/60">
          <p>© {new Date().getFullYear()} {BRAND.name}. By the <WVELink className="!no-underline">{BRAND.parent}</WVELink> team.</p>
          <a
            href="https://www.wvegroup.co.uk/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-wve-group-link"
            className="inline-flex items-center gap-2 hover:text-bde-pink transition-colors"
          >
            Part of <span className="text-bde-pink">The WVE Group</span>
          </a>
          <p>Made with ♥ in Essex</p>
        </div>
      </div>

      <div className="pointer-events-none select-none px-4">
        <div className="font-display font-black leading-[0.8] tracking-[-0.03em] text-bde-pink/15 text-[20vw] text-center">
          BEST DAY EVER
        </div>
      </div>
    </footer>
  );
}
